// app/router.options.ts
export default {
  scrollBehavior() {
    return { top: 0 };
  },
};
